import React, { useContext, useState, useEffect } from 'react';
import { formatDate } from '../../../../assets/js/utils/formatDate';
import { PriceCalculationContext } from '../../PriceCalculationContext';
import { Select } from '../../../../molecules/input/Select/Select';

function SelectStartDate() {
    const { productData, resourcedTexts } = useContext(PriceCalculationContext);
    const dateData = productData?.dateData || [];
    const [endDate, setEndDate] = useState(dateData && dateData.length > 0 ? dateData[0].endDate : '');

    useEffect(() => {
        setEndDate(dateData && dateData.length > 0 ? dateData[0].endDate : '');
    }, [productData]);

    function handleSelect(e) {
        const selectedStartDate = e.target.value;
        const selectedDateObj = dateData.find(({ startDate }) => startDate === selectedStartDate);
        setEndDate(selectedDateObj.endDate);
    }

    return (
        <div className="select-start-date">
            <h4 className="select-start-date__heading">{resourcedTexts.endDateFixedHeading}</h4>

            <div className="row">
                <div className="col-12 col-lg-6">
                    <Select
                        name="startDate"
                        labelText={resourcedTexts.startDateLabel}
                        handleInputChange={handleSelect}
                        options={dateData.map(({ startDate }) => {
                            return {
                                value: startDate,
                                text: formatDate(startDate),
                            };
                        })}
                    />
                </div>
                <div className="col-12 col-lg-6">
                    <label className="select-start-date__label">{resourcedTexts.endDateLabel}</label>
                    <div className="select-start-date__end-date">{formatDate(endDate)}</div>
                    <input name="endDate" type="hidden" value={endDate} />
                </div>
            </div>
        </div>
    );
}

export { SelectStartDate };
